import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { SurveyConfigurationService } from '../../../../../services/admin/survey-configuration/survey-configuration.service';

export interface SurveyPopupDialogData {
  wwid: number;
  survey_id: number;
  survey_link: string;
  remind_buttons_visible: boolean;
}

@Component({
  selector: 'app-survey-popup',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: './survey-popup.component.html',
  styleUrl: './survey-popup.component.scss'
})
export class SurveyPopupComponent implements OnDestroy {

  isLoading = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<SurveyPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SurveyPopupDialogData,
    private surveyConfigurationService: SurveyConfigurationService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onOpenSurvey(): void {
    this.isLoading = true;
    this.surveyConfigurationService
      .markParticipated(this.data.wwid, this.data.survey_id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          window.open(this.data.survey_link, '_blank');
          this.dialogRef.close('participated');
        },
        error: () => {
          window.open(this.data.survey_link, '_blank');
          this.dialogRef.close('participated');
        }
      });
  }

  onRemindLater(): void {
    this.isLoading = true;
    this.surveyConfigurationService
      .remindLater(this.data.wwid, this.data.survey_id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.dialogRef.close('remind_later'),
        error: () => this.dialogRef.close('remind_later')
      });
  }

  onRemindTomorrow(): void {
    this.isLoading = true;
    this.surveyConfigurationService
      .remindTomorrow(this.data.wwid, this.data.survey_id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.dialogRef.close('remind_tomorrow'),
        error: () => this.dialogRef.close('remind_tomorrow')
      });
  }

  onOptOut(): void {
    this.isLoading = true;
    this.surveyConfigurationService
      .optOut(this.data.wwid, this.data.survey_id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.dialogRef.close('opt_out'),
        error: () => this.dialogRef.close('opt_out')
      });
  }

  onClose(): void {
    this.dialogRef.close(null);
  }
}
